import { CentralProfileLink } from './CentralAccounts';
export default function ChangePassword() { return <CentralProfileLink path="/identity-email" />; }
